/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Auto_FormatInputs */

const en_shortcut_keys_name_auto_format = /** @type {(inputs: Shortcut_Keys_Name_Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto Format`)
};

const fr_shortcut_keys_name_auto_format = /** @type {(inputs: Shortcut_Keys_Name_Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatage auto`)
};

const de_shortcut_keys_name_auto_format = /** @type {(inputs: Shortcut_Keys_Name_Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Formatierung`)
};

const it_shortcut_keys_name_auto_format = /** @type {(inputs: Shortcut_Keys_Name_Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato automatico`)
};

const ru_shortcut_keys_name_auto_format = /** @type {(inputs: Shortcut_Keys_Name_Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоформатирование`)
};

const es_shortcut_keys_name_auto_format = /** @type {(inputs: Shortcut_Keys_Name_Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato automático`)
};

const zh_cn2_shortcut_keys_name_auto_format = /** @type {(inputs: Shortcut_Keys_Name_Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动格式`)
};

const ja_shortcut_keys_name_auto_format = /** @type {(inputs: Shortcut_Keys_Name_Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動フォーマット`)
};

const hi_shortcut_keys_name_auto_format = /** @type {(inputs: Shortcut_Keys_Name_Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑटो फॉर्मेट`)
};

const pt_pt2_shortcut_keys_name_auto_format = /** @type {(inputs: Shortcut_Keys_Name_Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatação automática`)
};

/**
* | output |
* | --- |
* | "Auto Format" |
*
* @param {Shortcut_Keys_Name_Auto_FormatInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_auto_format = /** @type {((inputs?: Shortcut_Keys_Name_Auto_FormatInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Auto_FormatInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_auto_format(inputs)
	if (locale === "de") return de_shortcut_keys_name_auto_format(inputs)
	if (locale === "it") return it_shortcut_keys_name_auto_format(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_auto_format(inputs)
	if (locale === "es") return es_shortcut_keys_name_auto_format(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_auto_format(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_auto_format(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_auto_format(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_auto_format(inputs)
	return en_shortcut_keys_name_auto_format(inputs)
});